
<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            <p>{{'Information' | translate | async}}</p>
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
<div >
    <div class="ttmodal__body" >
        <h3>{{'Please enter component extra details prior to sprocket hardware' | translate | async}}</h3>
    </div>
    <div class="ttmodal__footer" style="text-align: right;">
        <button mat-raised-button color="warn"  (click)="onNoClick()">
            <span class="button__text">{{'Ok' | translate | async}}</span>
        </button>
    </div>
</div>
</div>